import { Avatar, Box, Slide, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import React, { useEffect, useMemo, useState } from 'react';
import useControlledNavigation from '../../hooks/useControlledNavigation';
import { useLocation } from 'react-router-dom';
import FullscreenButton from '../Buttons/FullSceenBtn';
import { useDispatch, useSelector } from 'react-redux';
import { setIsMobileZoom } from '../../redux/reducers/controllNavigation';

const BottomNavBarMobile = () => {
  const [activeSubNav, setActiveSubNav] = useState('');
  const [activeNav, setActiveNav] = useState('');
  const [overflowMenuOpen, setOverflowMenuOpen] = useState(false);
  const [isMuiModalOpen, setIsMuiModalOpen] = useState(false);
  const navigate = useControlledNavigation();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname + location.search;

    const matchedMenu = menus.find(
      (item) => (item.subNav && currentPath === item.subNav) || (item.mainNav && currentPath === item.mainNav)
    );

    if (matchedMenu) {
      const isSubNavPath = matchedMenu.subNav && currentPath === matchedMenu.subNav;
      const isMainNavPath = matchedMenu.mainNav && currentPath === matchedMenu.mainNav;
      const samePath = matchedMenu.mainNav === matchedMenu.subNav;
      if (isSubNavPath && !samePath) {
        setActiveSubNav(matchedMenu.subNav);
        setActiveNav('');
      } else if (isMainNavPath || samePath) {
        setActiveSubNav('');
        setActiveNav(matchedMenu.mainNav);
      }
    }
    if (currentPath == '/') {
      setActiveNav('/?active=Business_Overview');
      setActiveSubNav('');
    }
  }, [location]);

  const iconStyle = useMemo(
    () => ({
      color: '#ffffff',
      fontSize: '10px',
      fontWeight: 'bold',
      borderRadius: '4px',
      height: '18px',
      width: '30px',
      backgroundColor: '#911B7C',
    }),
    []
  );

  const menus = useMemo(
    () => [
      {
        menu: 'dashboard',
        title: 'Dashboard',
        mainNav: '/?active=Business_Overview',
        tooltip: '',
        toolTipMain: '',
        // icon: <Avatar variant="rounded" sx={{ color: state.openMenu.dashboard && (state.selectMenu == 'dashboard') ? '#ffffff' : '#ffffff', fontSize: '12px', fontWeight: 'bold', backgroundColor: 'rgb(255 255 255 / 20%)', borderRadius: '3px', height: '30px', width: '30px' }}>DaB</Avatar>,
        icon: (
          //   <Avatar variant="rounded" sx={iconStyle}>
          //     DaB
          //   </Avatar>
          <img src="/dashboard.png" alt="Dashboard" style={{ width: '30px', height: '30px' }} />
        ),
        //   submenuColor:theme.palette.secondary.main,
        submenus: [],
        nav: '/?active=Business_Overview',
      },
      {
        menu: 'inventory',
        title: 'Items',
        mainNav: '/newItemList',
        subNav: '/additem',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Item',
        toolTipMain: 'View Item List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Itm
          </Avatar>
        ),
        //   submenuColor:theme.palette.secondary.main,
        submenus: [],
      },
      {
        menu: 'customer',
        title: 'Customer',
        mainNav: '/customerList',
        subNav: '/addcustomer',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Customer',
        toolTipMain: 'View Customer List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Cus
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:cousColor,
      },
      {
        menu: 'Sales',
        title: 'Sales',
        mainNav: '/salesInvoiceReport',
        subNav:
          // gstStatus == 1 ? "/addinvoiceNonTaxable" : "/addinvoiceTaxable",
          '/addnewinvoicetax',
        //   subNavDisabled: Freeze,
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        toolTipMain: 'View Sales Invoice List',
        tooltip: 'Add Invoice',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Sinv
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:cousColor,
      },
      {
        menu: 'POS',
        title: 'POS',
        mainNav: '/allpos',
        subNav: '/newpos',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        toolTipMain: 'View POS Invoice List',
        tooltip: 'Add Pos',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Pos
          </Avatar>
        ),
        submenus: [],
        //    submenuColor:cousColor,
      },
      {
        menu: 'receipts',
        title: 'Receipts',
        mainNav: '/receipts',
        subNav: '/addreceipts',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Receipts',
        toolTipMain: 'View Receipt List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Rec
          </Avatar>
        ),
        submenus: [
          // {
          //   name: 'Receipts',
          //   nav: '/receipts'
          // },
          // {
          //   name: 'Add Receipts',
          //   nav: '/addreceipts'
          // },
        ],
        //    submenuColor:cousColor,
      },
      {
        menu: 'supplier',
        title: 'Supplier',
        mainNav: '/supplierList',
        subNav: '/addsupplier',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Supplier',
        toolTipMain: 'View Supplier List',
        icon: (
          <Avatar
            variant="rounded"
            sx={iconStyle}
            // sx={menuStyle}
          >
            Sup
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:supColor,
      },
      {
        menu: 'Purchase Invoices',
        title: 'Purchase',
        mainNav: '/allpurchaseandexpense',
        subNav:
          // gstStatus == 1
          //   ? "/addpurchaseandexpensenontaxable"
          //   : "/addpurchaseandexpensetaxable",
          '/addnewpurchasetax',
        //   subNavDisabled: Freeze,
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        toolTipMain: 'View Purchase Invoice List',
        tooltip: 'Add Purchase Invoice',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Pinv
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:supColor,
      },
      {
        menu: 'payments',
        title: 'Payments',
        mainNav: '/paymententries',
        subNav: '/addpaymententries',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Payment',
        toolTipMain: 'View Payment List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Pay
          </Avatar>
        ),
        submenus: [
          // {
          //   name: 'Payment Entries',
          //   nav: '/paymententries'
          // },
          // {
          //   name: 'Add Payment Entries',
          //   nav: '/addpaymententries'
          // },
        ],
        //   submenuColor:supColor,
      },
      {
        menu: 'Debit Note /Purchase Return',
        title: 'Debit Note',
        mainNav: '/alldebitnote',
        subNav: '/adddebitnote',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Debit Note',
        toolTipMain: 'View Debit Note List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Drn
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:dbnColor,
      },
      {
        menu: 'Credit Note / Sales Return',
        title: 'Credit Note',
        mainNav: '/allcreditnote',
        subNav: '/addcreditnote',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Credit Note',
        toolTipMain: 'View Credit Note List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Crn
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:dbnColor,
      },
      {
        menu: 'Journal Entries',
        title: 'Journal',
        mainNav: '/journalentries',
        subNav: '/addjournalentry',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Journal Entries',
        toolTipMain: 'View Journal Entries List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            JV
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:jvColor,
      },
      {
        menu: 'Opening Balance',
        title: 'Op. Bal.',
        mainNav: '/openingbalance',
        subNav: '/openingbalance',
        subNAvIcon: (
          <AddIcon
            sx={{
              background: 'transparent',
              width: '12px',
              height: '12px',
              color: '#fb3b6fff',
              borderRadius: '2px',
            }}
          />
        ),
        //   subNavDisabled: Freeze,
        tooltip: 'Add Opening Balance',
        toolTipMain: 'View Opening Balance List',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            OpB
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:jvColor,
      },

      {
        menu: 'profitAndLose',
        title: 'P&L',
        mainNav: '/?active=ProfitAndLoss',
        tooltip: '',
        toolTipMain: '',
        // icon: <Avatar variant="rounded" sx={{ color: state.openMenu.dashboard && (state.selectMenu == 'dashboard') ? '#ffffff' : '#ffffff', fontSize: '12px', fontWeight: 'bold', backgroundColor: 'rgb(255 255 255 / 20%)', borderRadius: '3px', height: '30px', width: '30px' }}>DaB</Avatar>,
        icon: (
          //   <Avatar variant="rounded" sx={iconStyle}>
          //     P&L
          //   </Avatar>
          <img src="/PL.png" alt="P&L" style={{ width: '30px', height: '30px' }} />
        ),
        //   submenuColor:theme.palette.secondary.main,
        submenus: [],
        // nav: '/?active=Business_Overview',
      },
      {
        menu: 'balanceSheet',
        title: 'BS',
        mainNav: '/?active=BalanceSheet',
        tooltip: '',
        toolTipMain: '',
        // icon: <Avatar variant="rounded" sx={{ color: state.openMenu.dashboard && (state.selectMenu == 'dashboard') ? '#ffffff' : '#ffffff', fontSize: '12px', fontWeight: 'bold', backgroundColor: 'rgb(255 255 255 / 20%)', borderRadius: '3px', height: '30px', width: '30px' }}>DaB</Avatar>,
        icon: (
          //   <Avatar variant="rounded" sx={iconStyle}>
          //     BS
          //   </Avatar>
          <img src="/BS.png" alt="BS" style={{ width: '30px', height: '30px' }} />
        ),
        //   submenuColor:theme.palette.secondary.main,
        submenus: [],
        // nav: '/?active=BalanceSheet',
      },
      {
        menu: 'reports',
        title: 'Reports',
        mainNav: '/reports',
        tooltip: '',
        toolTipMain: 'View Reports',
        icon: (
          //   <Avatar variant="rounded" sx={iconStyle}>
          //     Rpt
          //   </Avatar>
          <img src="/ACC.png" alt="Accounts" style={{ width: '30px', height: '30px' }} />
        ),
        submenus: [],
        //   submenuColor:jvColor,
      },
      {
        menu: 'accounts',
        title: 'Accounts',
        mainNav: '/accounts',
        subNav: '/',
        toolTipMain: 'View Accounts ',
        // subNav: '',
        tooltip: '',
        icon: (
          <Avatar variant="rounded" sx={iconStyle}>
            Acc
          </Avatar>
        ),
        submenus: [],
        //   submenuColor:jvColor,
      },
    ],
    []
  );

  const mainMenuItems = useMemo(() => menus.filter((item) => !item.subNav).slice(0, 4), [menus]);

  const overflowMenuItems = useMemo(() => menus.filter((item) => item.subNav), [menus]);
  const dispatch = useDispatch()

  const handleOverflowItemClick = (e, item) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (item?.mainNav) {
      navigate(item.mainNav);
      setOverflowMenuOpen(false);
    }
  };

  const handleOverflowSubNavClick = (e, item) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (item?.subNav) {
      navigate(item.subNav);
      setOverflowMenuOpen(false);
    }
  };

  // Redux state flag (not the action)
  const setIsAnyModalOpen = useSelector(
    (state) => state?.controllNavigationSlice?.setIsAnyModalOpen
  );

  useEffect(() => {
    const checkModalOpen = () => {
      const hasOpenMuiModal =
        Boolean(document.querySelector('.MuiModal-root')) ||
        Boolean(document.querySelector('.MuiDialog-root')) ||
        Boolean(document.querySelector('[role="dialog"]'));
      setIsMuiModalOpen(hasOpenMuiModal);
    };

    checkModalOpen();
    const observer = new MutationObserver(checkModalOpen);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  const isAnyModalOpen = Boolean(setIsAnyModalOpen || isMuiModalOpen);
  const navLayerBaseZIndex = overflowMenuOpen ? 1400 : isAnyModalOpen ? 100 : 3000;

  const renderNavItem = (item, index) => (
    <Box
      key={index}
      sx={{ pointerEvents: 'auto', height: '100%', flexShrink: 0 }}
      onClick={(e) => {
        e.preventDefault();
        if (item.mainNav) navigate(item.mainNav);
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          gap: '2px',
        }}
      >
        {/* <Box
          sx={{
            height: '40%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: item?.subNav?.length > 0 ? '5px' : '30px',
          }}
        >
          {item?.subNav?.length > 0 ? (
            <Tooltip title={item.tooltip} placement="top">
              <Box
                onClick={(e) => {
                  e.preventDefault();
                  navigate(item.subNav);
                }}
                sx={{
                  width: '22px',
                  height: '22px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  border: activeSubNav === item.subNav ? '1px solid #fb3b6fff' : '2px solid transparent',
                }}
              >
                {item.subNAvIcon}
              </Box>
            </Tooltip>
          ) : null}
        </Box> */}
        <Box
          sx={{
            display: 'inline-flex',
            '& img': {
              transition: 'filter 0.2s ease',
              width: '24px',
              height: '24px',
              filter:
                activeNav === item.mainNav
                  ? 'brightness(0) saturate(100%) invert(39%) sepia(91%) saturate(2924%) hue-rotate(321deg)'
                  : 'none',
            },
            '& .MuiAvatar-root': {
              transition: 'box-shadow 0.2s ease, background-color 0.2s ease',
              ...(activeNav === item.mainNav && {
                boxShadow: '0 0 0 2px #fb3b6f',
                backgroundColor: 'rgba(251, 59, 111, 0.85)',
              }),
            },
          }}
        >
          {item.icon}
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textWrap: 'nowrap',
          }}
        >
          <Typography
            sx={{
              fontSize: '9px !important',
              fontWeight: 700,
              lineHeight: 1,
              cursor: item.mainNav ? 'pointer' : 'default',
              letterSpacing: '0.4px',
              color: activeNav === item.mainNav ? '#fb3b6f' : '#333',
              textShadow: activeNav === item.mainNav ? '0 1px 2px rgba(251,59,111,0.25)' : '0 1px 1px rgba(0,0,0,0.15)',
              transition: 'all 0.2s ease',
            }}
          >
            {item.title}
          </Typography>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 5,
        left: 5,
        right: 5,
        zIndex: navLayerBaseZIndex,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        borderRadius: '50px',
      }}
    >
      {/* Backdrop - closes overflow menu when clicking outside */}
      {overflowMenuOpen && (
        <Box
          onClick={() => setOverflowMenuOpen(false)}
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.15)',
            zIndex: navLayerBaseZIndex - 1,
            animation: 'fadeIn 0.2s ease-out',
            '@keyframes fadeIn': {
              from: { opacity: 0 },
              to: { opacity: 1 },
            },
          }}
        />
      )}

      {/* Overflow menu card - appears above the main nav bar with slide animation */}
      <Box
        sx={{
          position: 'absolute',
          bottom: '100%',
          left: 10,
          right: 10,
          mb: '-2px',
          overflow: 'hidden',
          zIndex: navLayerBaseZIndex + 1,
          pointerEvents: overflowMenuOpen ? 'auto' : 'none',
        }}
      >
        <Slide
          in={overflowMenuOpen}
          direction="up"
          timeout={{
            enter: 300,
            exit: 250,
          }}
          mountOnEnter
          unmountOnExit
        >
          <Box
            sx={{
              position: 'relative',
              backgroundColor: 'rgb(255, 252, 252)',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              borderRadius: '12px',
              boxShadow: '0 -4px 20px rgba(0,0,0,0.12)',
              padding: '15px',
            }}
          >
            <Box
              sx={{
                maxHeight: '40vh',
                overflowX: 'hidden',
                overflowY: 'auto',
                display: 'grid',
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                gap: '15px',
                pb: '64px', // space for fixed fullscreen button
                /* hide scrollbar */
                scrollbarWidth: 'none',
                '&::-webkit-scrollbar': { display: 'none' },
              }}
            >
              {overflowMenuItems.map((item, index) => (
                <Box
                  key={index}
                  onClick={(e) => handleOverflowItemClick(e, item)}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '15px',
                    padding: '15px',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    minWidth: 0,
                    WebkitTapHighlightColor: 'transparent',
                    outline: 'none',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
                    '&:active': { backgroundColor: 'transparent' },
                    transition: 'background-color 0.2s',
                  }}
                >
                  {item.subNAvIcon && (
                    <Tooltip title={item.tooltip} placement="top">
                      <Box
                        onClick={(e) => handleOverflowSubNavClick(e, item)}
                        sx={{
                          width: '16px',
                          height: '16px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '50%',
                          cursor: 'pointer',
                          WebkitTapHighlightColor: 'transparent',
                          outline: 'none',
                          border: activeSubNav === item.subNav ? '2px solid #fb3b6fff' : 'none',
                          backgroundColor: activeSubNav === item.subNav ? 'rgba(251, 59, 111, 0.1)' : 'transparent',
                        }}
                      >
                        {item.subNAvIcon}
                      </Box>
                    </Tooltip>
                  )}
                  <Typography
                    component="span"
                    sx={{
                      fontSize: '12px !important',
                      fontWeight: 'bold',
                      //   fontWeight: activeNav === item.mainNav ? 700 : 600,
                      color: activeNav === item.mainNav ? '#fb3b6fff' : '#333',
                      lineHeight: 1,
                      textAlign: 'center',
                      //   userSelect: 'none',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      width: '100%',
                      minWidth: 0,
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Fixed fullscreen button inside card */}
            <Box
              sx={{
                position: 'absolute',
                right: 12,
                bottom: 12,
                zIndex: 2,
              }}
              onClick={() => dispatch(setIsMobileZoom(true))}
            >
              <FullscreenButton />
            </Box>
          </Box>
        </Slide>
      </Box>

      {/* Main nav bar - 5 items: hamburger always centered + 4 without subNav */}
      <Box
        sx={{
          height: '50px',
          width: '100%',
          backgroundColor: 'rgba(239, 239, 239, 0.74)',
          backdropFilter: 'blur(3px)',
          WebkitBackdropFilter: 'blur(3px)',
          padding: '0 8px',
          boxSizing: 'border-box',
          boxShadow: '0 -2px 8px rgba(0,0,0,0.15)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '18px',
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr minmax(40px, auto) 1fr 1fr',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            maxWidth: '100%',
            gap: '2px',
          }}
        >
          {/* Items 1 & 2 (left) */}
          {mainMenuItems.slice(0, 2).map((item, index) => (
            <Box key={index} sx={{ display: 'flex', justifyContent: 'center' }}>
              {renderNavItem(item, index)}
            </Box>
          ))}

          {/* Center: Hamburger when closed, Close icon when open - always centered */}
          <Box
            onClick={() => setOverflowMenuOpen((prev) => !prev)}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              padding: '4px',
              borderRadius: '8px',
              backgroundColor: overflowMenuOpen ? 'rgba(145, 27, 124, 0.15)' : 'transparent',
              transition: 'background-color 0.2s',
              justifySelf: 'center',
            }}
          >
            {overflowMenuOpen ? (
              <CloseIcon sx={{ fontSize: 26, color: '#911B7C' }} />
            ) : (
              <Box
                sx={{
                  padding: '3px',
                  backgroundColor: 'white',
                  height: 25,
                  width: 25,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 0 0 2px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.12)',
                }}
              >
                <Box
                  sx={{
                    width: 22,
                    height: 22,
                    borderRadius: '50%',
                    backgroundColor: '#fb3b6fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <AddIcon sx={{ fontSize: 13, color: 'white', fontWeight: 'bold' }} />
                </Box>
              </Box>
            )}
          </Box>

          {/* Items 3 & 4 (right) */}
          {mainMenuItems.slice(2, 4).map((item, index) => (
            <Box key={index + 2} sx={{ display: 'flex', justifyContent: 'center' }}>
              {renderNavItem(item, index + 2)}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default BottomNavBarMobile;
